export const FIRST_DAILY_DEVIATION_DATE = '2000-08-15';
